module.exports = __webpack_public_path__ + "img/icon-ranking.587f373c.png";